// material-ui
import { styled } from "@mui/material/styles";

// third-party
import { SnackbarProvider } from "notistack";

// project imports

// assets
import CheckCircleOutlined from "@ant-design/icons/CheckCircleOutlined";
import CloseCircleOutlined from "@ant-design/icons/CloseCircleOutlined";
import InfoCircleOutlined from "@ant-design/icons/InfoCircleOutlined";
import WarningOutlined from "@ant-design/icons/WarningOutlined";

// custom styles
const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  "&.notistack-MuiContent-default": {
    background: theme.palette.primary.main,
  },
  "&.notistack-MuiContent-error": {
    background: theme.palette.error.main,
  },
  "&.notistack-MuiContent-success": {
    background: theme.palette.success.main,
  },
  "&.notistack-MuiContent-info": {
    background: theme.palette.info.main,
  },
  "&.notistack-MuiContent-warning": {
    background: theme.palette.warning.main,
  },
}));

// ===========================|| SNACKBAR - NOTISTACK ||=========================== //

type NotistackProps = {
  children: React.ReactNode;
  maxSnack?: number;
  dense?: boolean;
  iconVariant?: "default" | "useemojis" | "hide";
};

export default function Notistack({ children, maxSnack = 3, dense = false, iconVariant = "default" }: NotistackProps) {
  const iconSX = { marginRight: 8, fontSize: "1.15rem" };

  return (
    <StyledSnackbarProvider
      maxSnack={maxSnack}
      dense={dense}
      anchorOrigin={{
        horizontal: "center",
        vertical: "bottom",
      }}
      iconVariant={
        iconVariant === "useemojis"
          ? {
              success: <CheckCircleOutlined style={iconSX} />,
              error: <CloseCircleOutlined style={iconSX} />,
              warning: <WarningOutlined style={iconSX} />,
              info: <InfoCircleOutlined style={iconSX} />,
            }
          : undefined
      }
      hideIconVariant={iconVariant === "hide"}
    >
      {children}
    </StyledSnackbarProvider>
  );
}
